import { ServerEventDto } from "../../api/interfaces/serverEventDto";

export type UiNotification = {
  id: string;
  text: string;
  createdAt: string;
  isRead: boolean;
  type: string;
  requestUuid?: string;
  attempts?: number;
  packageId?: number;
  packageName?: string;
  orderId?: number;
  userId?: number;
  raw?: ServerEventDto;
};

export function mapServerEventToUi(dto: ServerEventDto): UiNotification | null {
  if (!dto.event_id) return null;

  return {
    id: String(dto.event_id),
    text: dto.message ?? "Новое уведомление",
    createdAt: dto.payload?.created_at ?? "",
    isRead: dto.is_read ?? false,
    type: dto.type,
    requestUuid: dto.payload?.request_uuid,
    attempts: dto.payload?.attempts,
    packageId: dto.payload?.package_id,
    packageName: dto.payload?.package_name,
    orderId: dto.payload?.order_id,
    userId: dto.payload?.user_id,
    raw: dto,
  };
}